import {
  USER_Delete_CART_ITEMS_LOADING,
  USER_Delete_CART_ITEMS_SUCCESS,
  USER_Delete_CART_ITEMS_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { createNewItemService } from "services/createNewItemService";
import { notification } from "antd";
import { userDeleteCartItemsUrl } from "api/apiUrls";

export const userDeleteCartItemsActions =
  (lang: any, userId: any, itemId: any, data: any, callback?: any) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch({ type: USER_Delete_CART_ITEMS_LOADING, payload: true });
      const response = await createNewItemService(
        `${userDeleteCartItemsUrl}${lang}/user/${userId}/item_id/${itemId}`,
        data,
        "",
        "json"
      );

      if (response.status === 200) {
        // notification.success({
        //   message: "Deleted",
        // });
        callback();
      }

      dispatch({
        type: USER_Delete_CART_ITEMS_SUCCESS,
        payload: response.data,
      });
    } catch (err: any) {
      notification.error({
        message: `${err.message}`,
      });
      dispatch({ type: USER_Delete_CART_ITEMS_FAILURE, payload: err });
    } finally {
      dispatch({ type: USER_Delete_CART_ITEMS_LOADING, payload: false });
    }
  };
